import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'

import Styles from './CampaignsNoResults.module.scss'

const CampaignsNoResults = () => {
  const { t } = useTranslation()

  return (
    <div className={Styles.wrapper} data-testid="campaigns-no-results">
      <img
        className={Styles.image}
        src="/images/emptyHistorySearch.svg"
        alt=""
      />
      <Text variant="heading-04" align="center">
        {t('marketing.campaigns.no-results-title')}
      </Text>
      <Text variant="subtitle" align="center" className={Styles.description}>
        {t('marketing.campaigns.no-results-description')}
      </Text>
    </div>
  )
}

export default CampaignsNoResults
